import { render, staticRenderFns } from "./SerahTerimaGadaiPerpanjangan.vue?vue&type=template&id=57ceefaa&"
import script from "./SerahTerimaGadaiPerpanjangan.vue?vue&type=script&lang=js&"
export * from "./SerahTerimaGadaiPerpanjangan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports